
define('ldsh!modules/start/products/trans/info/template', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="col-xs-8 col-sm-10 col-md-10 col-lg-10">\n    <div class="row">\n        <div class="col-md-12 col-lg-12">\n            <h3 class="i18n" style="margin-top: 5px;" data-i18n="PUBLIC.PRODUCTS.TRANS.PRODUCT_NAME"></h3>\n        </div>\n    </div>\n    <div class="row">\n        <div class="col-md-12 col-lg-12" style="min-height: 27px;">\n            ';
 if (!isStarter){ ;
__p += '\n            <p>\n                <b class="i18n" data-i18n="PUBLIC.PRODUCTS.TRANS.INFO.SUBTITLE"></b>\n            </p>\n            ';
 } else { ;
__p += '\n            <p>\n                <b class="i18n red" data-i18n="PUBLIC.PRODUCTS.TRANS.INFO.SUBTITLE_STARTER"></b> - <a id="email-update-plan"\n                  href="' +
__e(paymentsUrl) +
'"\n                  class="i18n ga-tag"\n                  data-i18n="PUBLIC.PRODUCTS.UPDATE_MONTHLY_PLAN"\n                  data-gacategory="Conversion"\n                  data-gaaction="Planes"\n                  data-galabel="Productos_Link_Email"\n                  data-gaevent="eventga" style="font-weight: bold;"></a>\n            </p>\n            ';
 } ;
__p += '\n        </div>\n    </div>\n    <div class="row">\n        <div class="col-md-12 col-lg-12" style="min-height: 19px;">\n            <table>\n                <tr>\n                    <td style="vertical-align: top;"><img class="product-check" src="/app/img/check_20.png"/></td>\n                    ';
 if (!isStarter){ ;
__p += '\n                        <td><span class="i18n" data-i18n="PUBLIC.PRODUCTS.TRANS.INFO.CHECK1"></span></td>\n                    ';
 } else { ;
__p += '\n                        <td><span class="i18n" data-i18n="PUBLIC.PRODUCTS.TRANS.INFO.CHECK_STARTER"></span>\n                            <span class="i18n" data-i18n="[html]PUBLIC.PRODUCTS.TRANS.INFO.MORE_INFO"></span></td>\n                    ';
 } ;
__p += '\n                </tr>\n            </table>\n        </div>\n    </div>\n</div>\n';

}
return __p
};});

